export const DIGITAL_CARD_STATUS_LABELS: Record<number, string> = {
  0: '草稿',
  1: '已发布',
  2: '已停用'
}

export const DIGITAL_CARD_THEME_LABELS: Record<string, string> = {
  gold: '金色商务',
  plain: '极简白',
  brand_v: '品牌竖版'
}

export const DIGITAL_CARD_THEME_ACCENTS: Record<string, string> = {
  gold: '#c89e62',
  plain: '#f5f5f5',
  brand_v: '#0f1c2e'
}

export const DIGITAL_CARD_WHITELIST_LABELS: Record<string, string> = {
  mobile: '手机',
  wechat: '微信',
  email: '邮箱',
  company: '公司',
  position: '职位',
  titleSecondary: '副职位',
  address: '地址',
  website: '网址',
  landline: '座机',
  hotline: '热线'
}

export function buildMobileCardUrl(userId: number, shareCode?: string) {
  const mobileBaseUrl = String(
    import.meta.env.VITE_MOBILE_H5_DOMAIN ||
      import.meta.env.VITE_MOBILE_BASE_URL ||
      (typeof window !== 'undefined' ? window.location.origin : '')
  ).replace(/\/$/, '')
  if (!mobileBaseUrl) return ''
  const url = new URL('/pages/modules/digital-card/pages/card/detail', `${mobileBaseUrl}/`)
  if (shareCode) {
    url.searchParams.set('shareCode', shareCode)
  } else {
    url.searchParams.set('id', String(userId))
  }
  return url.toString()
}
